import React, { useState } from 'react';
import './dashboard.component.css';

// Simulated MainFooter component (replace with your actual import)
import MainFooter from '../Common/MainFooter';

const Dashboard = () => {
  const [websites] = useState([
    {
      id: 1,
      name: 'Main Website',
      url: 'example.com',
      favicon: '🌐',
      lastAudit: '2 hours ago',
      seoScore: 87,
      issues: 5
    },
    {
      id: 2,
      name: 'Blog Site',
      url: 'blog.example.com',
      favicon: '📝',
      lastAudit: '1 day ago',
      seoScore: 72,
      issues: 12
    },
    {
      id: 3,
      name: 'E-commerce Store',
      url: 'shop.example.com',
      favicon: '🛒',
      lastAudit: '3 days ago',
      seoScore: 91,
      issues: 3
    }
  ]);

  const [auditHistory] = useState([
    { website: 'example.com', date: '2025-01-15', scoreChange: '+5', issues: 5, id: 1 },
    { website: 'blog.example.com', date: '2025-01-14', scoreChange: '-2', issues: 12, id: 2 },
    { website: 'shop.example.com', date: '2025-01-13', scoreChange: '+8', issues: 3, id: 3 },
    { website: 'example.com', date: '2025-01-12', scoreChange: '+3', issues: 8, id: 4 }
  ]);

  const [alerts] = useState([
    { type: 'warning', message: 'Ranking dropped for 3 keywords on example.com', time: '1 hour ago' },
    { type: 'danger', message: 'Traffic decreased by 15% on blog.example.com', time: '3 hours ago' },
    { type: 'info', message: '5 pages not indexed on shop.example.com', time: '1 day ago' }
  ]);

  const [recommendations] = useState([
    { title: 'Fix 12 broken links', priority: 'high', website: 'blog.example.com' },
    { title: 'Improve Core Web Vitals', priority: 'medium', website: 'example.com' },
    { title: 'Compress 45 images', priority: 'low', website: 'shop.example.com' },
    { title: 'Add missing meta descriptions', priority: 'high', website: 'example.com' }
  ]);

  const getScoreClass = (score) => {
    if (score >= 80) return 'score-good';
    if (score >= 60) return 'score-medium';
    return 'score-poor';
  };

  const getPriorityBadge = (priority) => {
    const badges = {
      high: 'badge-danger',
      medium: 'badge-warning',
      low: 'badge-info'
    };
    return badges[priority] || 'badge-secondary';
  };

  return (
    <div className="dashboard-wrapper">
      <div className="container-fluid dashboard-container">
        {/* Header Summary */}
        <div className="dashboard-header">
          <div className="row align-items-center mb-4">
            <div className="col-md-6">
              <h1 className="dashboard-title">SEO Dashboard</h1>
              <p className="dashboard-subtitle">Welcome back! Here's your SEO overview.</p>
            </div>
          </div>

          <div className="row g-4 mb-5">
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">🌐</div>
                <div className="stat-content">
                  <div className="stat-label">Total Websites</div>
                  <div className="stat-value">3</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">📊</div>
                <div className="stat-content">
                  <div className="stat-label">Total Audits</div>
                  <div className="stat-value">127</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">💚</div>
                <div className="stat-content">
                  <div className="stat-label">Avg SEO Health</div>
                  <div className="stat-value">83%</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-icon">⚠️</div>
                <div className="stat-content">
                  <div className="stat-label">Pending Issues</div>
                  <div className="stat-value">20</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Website Cards */}
        <div className="section-header mb-4">
          <h2>Your Websites</h2>
        </div>
        <div className="row g-4 mb-5">
          {websites.map((site) => (
            <div key={site.id} className="col-md-4">
              <div className="website-card">
                <div className="website-header">
                  <div className="website-info">
                    <span className="website-favicon">{site.favicon}</span>
                    <div>
                      <h3 className="website-name">{site.name}</h3>
                      <a href={`https://${site.url}`} className="website-url" target="_blank" rel="noopener noreferrer">
                        {site.url}
                      </a>
                    </div>
                  </div>
                  <div className="dropdown">
                    <button className="btn-settings" data-bs-toggle="dropdown">⚙️</button>
                    <ul className="dropdown-menu">
                      <li><a className="dropdown-item" href="#edit">Edit</a></li>
                      <li><a className="dropdown-item" href="#delete">Delete</a></li>
                    </ul>
                  </div>
                </div>
                <div className="website-stats">
                  <div className="stat-item">
                    <span className="stat-item-label">Last Audit</span>
                    <span className="stat-item-value">{site.lastAudit}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-item-label">SEO Score</span>
                    <span className={`stat-item-value ${getScoreClass(site.seoScore)}`}>{site.seoScore}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-item-label">Issues</span>
                    <span className="stat-item-value issue-count">{site.issues}</span>
                  </div>
                </div>
                <div className="website-actions">
                  <button className="btn btn-primary btn-sm">View Insights</button>
                  <button className="btn btn-outline-primary btn-sm">Run Audit</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row g-4 mb-5">
          {/* Recent Audit Activity */}
          <div className="col-lg-8">
            <div className="content-card">
              <div className="card-header-custom">
                <h3>Recent Audit Activity</h3>
              </div>
              <div className="table-responsive">
                <table className="table audit-table">
                  <thead>
                    <tr>
                      <th>Website</th>
                      <th>Date</th>
                      <th>Score Change</th>
                      <th>Issues Found</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {auditHistory.map((audit) => (
                      <tr key={audit.id}>
                        <td className="website-col">{audit.website}</td>
                        <td>{audit.date}</td>
                        <td>
                          <span className={audit.scoreChange.startsWith('+') ? 'score-positive' : 'score-negative'}>
                            {audit.scoreChange}
                          </span>
                        </td>
                        <td>{audit.issues}</td>
                        <td>
                          <button className="btn-link">View Report</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="col-lg-4">
            <div className="content-card">
              <div className="card-header-custom">
                <h3>Quick Actions</h3>
              </div>
              <div className="quick-actions">
                <button className="action-btn">➕ Add New Website</button>
                <button className="action-btn">🔄 Run Audit</button>
                <button className="action-btn">📥 Download Report</button>
                <button className="action-btn">🔔 View Alerts</button>
                <button className="action-btn">🔗 Connect Google Analytics</button>
                <button className="action-btn">🔗 Connect Search Console</button>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-5">
          {/* Alerts Panel */}
          <div className="col-lg-6">
            <div className="content-card">
              <div className="card-header-custom">
                <h3>🔔 Alerts</h3>
              </div>
              <div className="alerts-list">
                {alerts.map((alert, index) => (
                  <div key={index} className={`alert-item alert-${alert.type}`}>
                    <div className="alert-content">
                      <p className="alert-message">{alert.message}</p>
                      <span className="alert-time">{alert.time}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recommendations */}
          <div className="col-lg-6">
            <div className="content-card">
              <div className="card-header-custom">
                <h3>💡 Recommendations</h3>
              </div>
              <div className="recommendations-list">
                {recommendations.map((rec, index) => (
                  <div key={index} className="recommendation-item">
                    <div className="rec-content">
                      <div className="rec-header">
                        <span className="rec-title">{rec.title}</span>
                        <span className={`priority-badge ${getPriorityBadge(rec.priority)}`}>
                          {rec.priority}
                        </span>
                      </div>
                      <span className="rec-website">{rec.website}</span>
                    </div>
                    <button className="btn-link-small">Fix →</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <MainFooter />
    </div>
  );
};

export default Dashboard;